export default __webpack_public_path__ + "static/media/slide11.b6f94fbd.jpg";